import moment from 'moment';

export const DATE_FORMAT = 'M/D/YYYY';

export const checkingFilterDatePickers = formVal => {
  const arrPickers = [
    'event_date_low',
    'event_date_low_raw',
    'event_date_high',
    'event_date_high_raw',
    'sb_last_invoice_date_low',
    'sb_last_invoice_date_low_raw',
    'sb_last_invoice_date_high',
    'sb_last_invoice_date_high_raw',
    'checked_low',
    'checked_high',
    'checked_low_raw',
    'checked_high_raw',
    'onsale_high',
    'onsale_high_raw',
    'onsale_low',
    'onsale_low_raw',
  ];
  const newFormVal = {
    ...formVal,
  };
  for (let i = 0; i < arrPickers.length; i += 1) {
    if (typeof newFormVal[arrPickers[i]] !== 'undefined') {
      if (newFormVal[arrPickers[i]] == null || newFormVal[arrPickers[i]] === '') {
        delete newFormVal[arrPickers[i]];
      }
    }
  }
  return newFormVal;
};

export const convertDateWithTimezone = (date, timezone, format) => {
  if (!timezone) {
    return moment.utc(date).format(format);
  }

  return moment
    .utc(date)
    .tz(timezone)
    .format(format);
};

export const getDisplayPaage = (page, pagePerSize, totalPages, totalEvents) => {
  return `${pagePerSize * (page - 1) + 1} - ${page === totalPages ? totalEvents : pagePerSize * page}`;
};

export const formatRequestParams = data => {
  const keys = Object.keys(data);
  const keysWithoutLowHigh = keys.filter(
    key => !key.includes('_low') && !key.includes('_high') && !key.includes('_start_date') && !key.includes('_end_date')
  );
  const keysWithLow = keys.filter(key => key.includes('_low'));
  const keysWithStartDate = keys.filter(key => key.includes('_start_date'));

  // form data range values
  const rangeFormData = keysWithLow.reduce((acc, keyLow) => {
    const distinctKey = keyLow.slice(0, -4);
    const keyHigh = `${distinctKey}_high`;
    const range1 = data[keyLow] || '';
    const range2 = data[keyHigh] || '';

    if (distinctKey === 'sb_last_invoice_date' && (range1 || range2)) {
      acc[distinctKey] = `${range1 && moment(range1).format(DATE_FORMAT)}:${range2 &&
        moment(range2).format(DATE_FORMAT)}`;
    } else if (range1 || range2) {
      acc[distinctKey] = `${range1}:${range2}`;
    }

    return acc;
  }, {});

  // form data with date range
  const dateRangeValues = keysWithStartDate.reduce((acc, key) => {
    const distinctKey = key.slice(0, -11);
    const keyEndDate = `${distinctKey}_end_date`;
    const range1 = (data[key] && moment(data[key]).format(DATE_FORMAT)) || '';
    const range2 = (data[keyEndDate] && moment(data[keyEndDate]).format(DATE_FORMAT)) || '';

    if (range1 || range2) {
      acc[distinctKey] = `${range1}:${range2}`;
    }
    return acc;
  }, {});

  // other form values
  const otherFormData = keysWithoutLowHigh.reduce((acc, key) => {
    if (data[key]) {
      acc[key] = data[key];
    }
    return acc;
  }, {});

  return {
    ...rangeFormData,
    ...dateRangeValues,
    ...otherFormData,
  };
};

export const rangeValuesParser = (keys, rangeValues) => {
  return keys.reduce((acc, key) => {
    const [startValue, endValue] = rangeValues[key].split(':');

    if (key === 'sb_last_invoice_date') {
      acc[`${key}_low`] = startValue ? moment(startValue, DATE_FORMAT) : '';
      acc[`${key}_high`] = endValue ? moment(endValue, DATE_FORMAT) : '';
    } else if (key.includes('_date') || ['checked', 'onsale'].includes(key)) {
      acc[`${key}_start_date`] = startValue ? moment(startValue, DATE_FORMAT) : '';
      acc[`${key}_end_date`] = endValue ? moment(endValue, DATE_FORMAT) : '';
    } else {
      acc[`${key}_low`] = startValue || '';
      acc[`${key}_high`] = endValue || '';
    }
    return acc;
  }, {});
};

export const parseFilterValues = data => {
  const { range, scalars } = Object.keys(data).reduce(
    (acc, filterKey) => {
      if (typeof data[filterKey] === 'string' && data[filterKey].includes(':')) {
        acc.range[filterKey] = data[filterKey];
      } else {
        acc.scalars[filterKey] = data[filterKey];
      }
      return acc;
    },
    { range: {}, scalars: {} }
  );
  const rangeKeys = Object.keys(range);

  const parsedRangeValues = rangeKeys.length ? rangeValuesParser(rangeKeys, range) : {};

  return {
    ...scalars,
    ...parsedRangeValues,
  };
};

export const arrayToQueryString = data => {
  const keysWithVaue = Object.keys(data).filter(key => data[key].length);
  const queryStringArr = keysWithVaue.map(key => {
    return data[key].map(value => `${key}=${value}`).join('&');
  });

  return queryStringArr.join('&');
};

export const getHedgeFundName = (hedgeFundID, organizations) => {
  if (hedgeFundID && organizations && organizations.length) {
    const filteredOrgs = organizations.filter(org => org.id === hedgeFundID);
    if (filteredOrgs.length) {
      return filteredOrgs[0].name;
    }
  }

  return 'None';
};
